/**
 * Textos en español
 * Propósito: paquete de idioma español (es)
 * Uso: registrado en i18n/index.js; leer con t('key')
 */
export default {
  common: {
    brandLogoAlt: 'Logo de la marca',
    home: 'Inicio',
    cases: 'Casos reales',
    contact: 'Contáctenos',
    getQuote: 'Obtener cotización',
    backHome: 'Volver al inicio',
    email: 'Correo',
    phone: 'Teléfono',
    loading: 'Cargando…',
    loadFailed: 'Error al cargar datos. Compruebe que el servidor API esté en ejecución.'
  },
  nav: {
    homeAria: 'Volver al inicio'
  },
  media: {
    video: 'Video',
    empty: 'No hay contenido multimedia',
    videoUnsupported: 'Su navegador no admite la reproducción de video.',
    videoThumb: 'Cambiar a video',
    imageThumb: 'Cambiar a imagen'
  },
  home: {
    title: 'Encuentre proveedores de calidad. Abastezca con confianza.',
    subtitle:
      'Explore imágenes de productos seleccionados y vea detalles de especificaciones, plazos y personalización.',
    browseProducts: 'Ver productos',
    galleryTitle: 'Galería de productos',
    galleryHint: 'Haga clic en cualquier imagen para ver los detalles',
    filterLabel: 'Categoría',
    filterAll: 'Todas',
    filterEmpty: 'No hay productos en esta categoría. Pruebe otra.'
  },
  categories: {
    industrial: 'Productos industriales',
    home: 'Artículos para el hogar',
    sportsOutdoor: 'Deporte y outdoor',
    kitchen: 'Cocina',
    electronics: 'Electrónica de consumo',
    office: 'Material de oficina',
    toys: 'Juguetes y regalos',
    bags: 'Bolsos y accesorios',
    tableware: 'Regalos de mesa',
    lighting: 'Iluminación',
    sportsProtection: 'Protección deportiva',
    daily: 'Artículos de uso diario'
  },
  product: {
    backList: '← Volver a productos',
    moq: 'Pedido mínimo: ',
    material: 'Material: ',
    leadTime: 'Plazo: ',
    inquire: 'Consultar compra',
    keepBrowsing: 'Seguir explorando',
    notFoundTitle: 'Producto no encontrado',
    notFoundDesc: 'Es posible que el producto no esté disponible o que el enlace no sea válido.'
  },
  contact: {
    title: 'Contáctenos',
    subtitle:
      'Todo empieza con un hola. Cuéntenos qué desea abastecer o personalizar y le responderemos pronto.',
    infoTitle: 'Información de contacto',
    officeLabel: 'Oficina en China',
    officeAddress: 'Pueblo de Huashan, Distrito Huadu, Guangzhou, Guangdong, China',
    emailValue: "2017emilyli{'@'}gmail.com",
    whatsappLabel: 'WhatsApp',
    whatsappValue: '18666080334',
    workHoursLabel: 'Horario laboral',
    workHours: 'Lun–Vie 09:00 – 18:00 (GMT+8)',
    formTitle: 'Enviar consulta',
    formTip: 'Complete el formulario y le responderemos lo antes posible.',
    name: 'Nombre *',
    namePlaceholder: 'Su nombre',
    company: 'Empresa',
    companyPlaceholder: 'Nombre de la empresa (opcional)',
    emailLabel: 'Correo *',
    phoneLabel: 'Teléfono',
    phonePlaceholder: 'Un número donde podamos contactarle',
    help: '¿En qué podemos ayudarle? *',
    helpPlaceholder:
      'Describa la categoría del producto, cantidad estimada, plazo u otras necesidades',
    wantCall: 'Deseo programar una llamada',
    submit: 'Enviar consulta',
    submitting: 'Enviando…',
    errorRequired: 'Complete todos los campos obligatorios.',
    errorEmail: 'Introduzca una dirección de correo válida.',
    success: '¡Gracias! Hemos recibido su mensaje y le contactaremos pronto.',
    fail: 'Error al enviar. Inténtelo de nuevo más tarde.'
  },
  footer: {
    desc: 'Conectamos con proveedores de calidad para facilitar el abastecimiento y la personalización.',
    quickLinks: 'Enlaces rápidos',
    contactTitle: 'Contacto',
    emailLine: "Correo: 2017emilyli{'@'}gmail.com",
    whatsappLine: 'WhatsApp: 18666080334',
    addressLine: 'Dirección: Pueblo de Huashan, Distrito Huadu, Guangzhou, Guangdong, China',
    rights: 'Todos los derechos reservados.'
  },
  lang: {
    label: 'Idioma',
    zh: '中文',
    en: 'English',
    es: 'Español'
  },
  meta: {
    home: 'Productos',
    productDetail: 'Detalle del producto',
    cases: 'Casos reales',
    caseDetail: 'Detalle del caso',
    contact: 'Contáctenos',
    admin: 'Panel de administración',
    adminLogin: 'Acceso admin'
  },
  cases: {
    title: 'Casos reales de abastecimiento',
    subtitle:
      'Vea cómo ayudamos a clientes de distintos sectores con sourcing, muestras, QC y entrega — con resultados claros.',
    filterLabel: 'Categoría del caso',
    filterAll: 'Todas',
    filterEmpty: 'No hay casos en esta categoría. Pruebe otra.',
    viewDetail: 'Ver detalle',
    backList: '← Volver a casos',
    challenge: 'El desafío',
    solution: 'Nuestra solución',
    result: 'El resultado',
    highlights: 'Puntos clave',
    cta: 'Consultar un proyecto similar',
    moreCases: 'Más casos',
    notFoundTitle: 'Caso no encontrado',
    notFoundDesc: 'Es posible que el caso no esté disponible o que el enlace no sea válido.',
    metrics: {
      saving: 'Ahorro de costo',
      units: 'Unidades entregadas',
      leadTime: 'Plazo de entrega'
    },
    items: {
      c1: {
        title: 'OEM de altavoz Bluetooth para e-commerce',
        client: 'Marca e-commerce de Norteamérica · Electrónica',
        summary:
          'Rediseño, firmware a medida y primer envío en 8 semanas, con una reducción de costo de alrededor del 22%.',
        challenge:
          'El proveedor anterior tenía plazos inestables y no podía soportar cambios de firmware en lotes pequeños antes de temporada alta.',
        solution:
          'Seleccionamos tres fábricas con experiencia exportadora, comparamos muestras con pruebas de terceros y fijamos ajustes de molde, empaque y buque con QC semanal.',
        result:
          'Primer pedido de 85.000 unidades a tiempo con defectos bajo 0,8%. Luego el cliente nos nombró socio exclusivo en China.',
        highlights: [
          'Pruebas IPX5 y de autonomía',
          'Personalización OEM de diseño y firmware',
          'Inspección AQL antes del envío'
        ]
      },
      c2: {
        title: 'Sets de cocina de silicona para retail',
        client: 'Cadena europea · Cocina',
        summary:
          'Sets de regalo multicolor para temporada festiva, con manuales multilingües y empaque antichoque.',
        challenge:
          'Alta exigencia de color y unboxing, manuales DE/FR/EN y fecha de buque para Navidad.',
        solution:
          'Elegimos fábrica con certificación alimentaria, confirmamos colores y piloto, y reservamos espacio con doble protección.',
        result:
          '120.000 sets entregados a tiempo con daños bajo 0,3%. El cliente renovó la siguiente temporada.',
        highlights: [
          'Material alimentario y certificados',
          'Manuales trilingües y cajas a medida',
          'Entrega festiva a tiempo'
        ]
      },
      c3: {
        title: 'Sustitución de cajas de herramientas industriales',
        client: 'Distribuidor australiano · Industrial',
        summary:
          'Reemplazo de importaciones costosas con producción local reforzada y ahorro cercano al 31%.',
        challenge:
          'Los productos europeos/EE. UU. eran caros; se requería igual durabilidad e impresión de marca propia.',
        solution:
          'Analizamos la estructura original, optimizamos bisagras y cierres, hicimos pruebas de carga/caída y personalizamos EVA e impresión.',
        result:
          '12.500 juegos entregados. Mejoró la recompra y bajó el costo unitario frente a la importación.',
        highlights: [
          'Pruebas de carga y caída aprobadas',
          'Impresión de marca propia',
          'Ahorro claro vs. importado'
        ]
      },
      c4: {
        title: 'Cajas de almacenamiento para marketplace',
        client: 'Marca DTC de SE Asia · Hogar',
        summary:
          'Matriz multi-talla con empaque y códigos de barras para un lanzamiento rápido en plataformas.',
        challenge:
          'Seis combinaciones debían salir rápido cumpliendo normas de empaque y barcode.',
        solution:
          'Planificamos familia de moldes, alineamos empaque/barcode y enviamos en dos oleadas para bajar inventario.',
        result:
          'Más de 200.000 unidades con rating 4,7+. Quedamos como proveedor anual clave.',
        highlights: [
          'SKU multi-talla rápidos',
          'Cajas y barcodes conformes',
          'Envíos por etapas'
        ]
      },
      c5: {
        title: 'Botella deportiva de colaboración',
        client: 'Marca deportiva LATAM · Outdoor',
        summary:
          'Impresión de colaboración, capacidad y cumplimiento export para el lanzamiento en un nuevo mercado.',
        challenge:
          'Alta precisión de impresión, normas de contacto alimentario y riesgo controlado en el primer pedido.',
        solution:
          'Usamos Tritan alimentario, confirmamos pruebas de color, preparamos documentos y sugerimos pedido piloto por SKU.',
        result:
          '60.000 unidades a tiempo; 70% vendido en la primera semana y reorden con nuevos colores.',
        highlights: [
          'Entrega conforme alimentaria',
          'Impresión de colaboración precisa',
          'Reorden rápido tras el lanzamiento'
        ]
      },
      c6: {
        title: 'Vajilla de cerámica para exportación festiva',
        client: 'Empresa de regalos canadiense · Mesa',
        summary:
          'Vajilla con esmalte y patrón a medida, más empaque antichoque para flete marítimo largo.',
        challenge:
          'Cerámica frágil y tránsito largo con historial de daños; el esmalte debía coincidir con la marca.',
        solution:
          'Mejoramos bandejas e intensidad de apilado, hicimos pruebas de transporte y cerramos esmalte en dos rondas.',
        result:
          '48.000 sets puestos en tienda con daños bajo 0,5%. Recompra en la siguiente temporada.',
        highlights: [
          'Esmalte y arte personalizados',
          'Empaque antichoque efectivo',
          'Suministro estable en temporada'
        ]
      }
    }
  },
  products: {
    p1: {
      name: 'Juego de cajas de herramientas',
      category: 'Productos industriales',
      moq: '500 juegos',
      material: 'ABS + acero',
      leadTime: '15–25 días',
      description:
        'Cajas de herramientas multiespecificación para fábricas y mantenimiento. Divisores, logo y colores personalizables.',
      specs: ['Estructura reforzada', 'Forro personalizable', 'Listo para OEM/ODM']
    },
    p2: {
      name: 'Serie de cajas de almacenamiento',
      category: 'Artículos para el hogar',
      moq: '1000 uds.',
      material: 'Plástico PP',
      leadTime: '12–20 días',
      description:
        'Almacenamiento ligero y duradero. Varios tamaños, empaque a color y etiquetas de código de barras para e-commerce.',
      specs: ['Varios tamaños', 'Diseño apilable', 'Cajas personalizadas']
    },
    p3: {
      name: 'Botella deportiva outdoor',
      category: 'Deporte y outdoor',
      moq: '2000 uds.',
      material: 'Tritan de grado alimentario',
      leadTime: '18–28 días',
      description:
        'Botella ligera a prueba de fugas para e-commerce y marcas. Color, capacidad, impresión y empaque personalizables.',
      specs: ['Material alimentario', 'Sello antirfugas', 'Impresión de marca']
    },
    p4: {
      name: 'Set de utensilios de silicona',
      category: 'Cocina',
      moq: '800 juegos',
      material: 'Silicona de grado alimentario',
      leadTime: '20–30 días',
      description:
        'Utensilios de silicona resistentes al calor. Combinaciones de color, accesorios y manuales personalizables.',
      specs: ['Resistente al calor', 'Compatible con antiadherente', 'Sets combinables']
    },
    p5: {
      name: 'Altavoz Bluetooth portátil',
      category: 'Electrónica de consumo',
      moq: '500 uds.',
      material: 'ABS + tejido',
      leadTime: '25–35 días',
      description:
        'Altavoz portátil con opciones OEM de diseño y firmware. Soporte de muestras, control de calidad y empaque de exportación.',
      specs: ['IPX5 impermeable', 'Autonomía personalizable', 'Firmware a medida']
    },
    p6: {
      name: 'Organizador de escritorio',
      category: 'Material de oficina',
      moq: '1000 uds.',
      material: 'Metal + madera',
      leadTime: '15–22 días',
      description:
        'Organizador minimalista para oficina y hogar. Ajustes de tamaño, acabados y placas de marca disponibles.',
      specs: ['Carga estable', 'Diseño minimalista', 'Placa personalizable']
    },
    p7: {
      name: 'Bloques educativos',
      category: 'Juguetes y regalos',
      moq: '600 juegos',
      material: 'ABS ecológico',
      leadTime: '22–30 días',
      description:
        'Bloques listos para exportación con apoyo en pruebas de seguridad y diseño de empaque. Temas y manuales multilingües.',
      specs: ['Cumple seguridad export', 'Temas personalizables', 'Manuales multilingües']
    },
    p8: {
      name: 'Set de organizadores de viaje',
      category: 'Bolsos y accesorios',
      moq: '1200 juegos',
      material: 'Nailon / poliéster',
      leadTime: '14–21 días',
      description:
        'Organizadores ligeros con combinaciones de color y talla. Ideales para e-commerce y empaques de co-branding.',
      specs: ['Ligeros y resistentes', 'Sets multipieza', 'Cremalleras a color']
    },
    p9: {
      name: 'Vajilla de cerámica en caja regalo',
      category: 'Regalos de mesa',
      moq: '400 juegos',
      material: 'Cerámica',
      leadTime: '25–40 días',
      description:
        'Vajilla de cerámica en caja regalo para fiestas y retail. Esmaltes, patrones y empaque antichoque personalizables.',
      specs: ['Empaque regalo', 'Esmalte personalizable', 'Empaque antichoque']
    },
    p10: {
      name: 'Lámpara LED ambiental',
      category: 'Iluminación',
      moq: '800 uds.',
      material: 'PC + aleación de aluminio',
      leadTime: '20–30 días',
      description:
        'Iluminación ambiental con temperatura de color y control personalizables. Soporte de muestras, QC y envíos.',
      specs: ['Varias temperaturas', 'Opciones mando/APP', 'Apariencia a medida']
    },
    p11: {
      name: 'Rodillera deportiva',
      category: 'Protección deportiva',
      moq: '1500 uds.',
      material: 'Neopreno / nailon',
      leadTime: '16–24 días',
      description:
        'Protección deportiva con matriz de tallas y opciones de empaque. Apta para e-commerce y OEM de marcas deportivas.',
      specs: ['Elástica y transpirable', 'Varias tallas', 'Etiquetas personalizadas']
    },
    p12: {
      name: 'Vaso térmico de acero',
      category: 'Artículos de uso diario',
      moq: '1000 uds.',
      material: 'Acero inoxidable 304',
      leadTime: '18–26 días',
      description:
        'Vaso de vacío de doble pared con recubrimiento, logo láser y caja regalo. Ideal para regalos corporativos y retail.',
      specs: ['Aislamiento al vacío', 'Logo láser', 'Caja regalo opcional']
    }
  }
}
